import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-point-up': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M105.6 83.2c0-45.1 38.1-83.2 83.2-83.2 45.6 0 83.2 37.8 83.2 83.2v35.6c6.4 1.4 16.3 5 22.1 7.9 22-2.5 45 3.5 62.8 16 52.5 1.1 91.1 37.4 91.1 99.9v21.3c0 60.1-40 98.5-40 127.2v2.7c5 5.7 8 13.5 8 22.1v64c0 17.7-12.9 32-28.8 32h-230.4c-15.9 0-28.8-14.3-28.8-32v-64c0-8.6 3-16.4 8-22.1v-2.7c0-7-6.2-14.9-23.7-30.2l-0.1-0.1-0.1-0.1c-9.9-8.9-20.8-18.1-33.3-25.9-30.2-18.7-78.8-30.4-78.8-75.7 0-56.9 35.3-92 83.2-92h0.1c6.2 0 16.2 1 22.3 2.2v-86.2zM224 83.2c0-19-16.2-35.2-35.2-35.2-18.7 0-35.2 16.8-35.2 35.2v158.4c-17.3 0-35.2-26.4-70.4-26.4-26.4 0-35.2 20.6-35.2 44 0 8.8 32.7 20.4 56.1 34.9 14.6 9.1 27.2 19.5 39.9 30.8 18.4 16.1 36.6 33.8 39.6 59.1h176.8c3.8-42.8 39.7-74.5 39.7-120v-21.3c0-40.5-22.2-57.1-61.3-50.6-8-14.6-34-24.2-53.6-12.9-18.2-19.4-46.4-17.8-61-5v-91zM352 424c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-point-up.js
// module id = 1769
// module chunks = 0